<template>
  <div class="rank-ing">
    <ul class="top-ul1">
      <li
        :class="islink==item.type ? 'li-sty li-check-sty' : 'li-sty'"
        v-for="(item,index) in liList"
        :key="index"
        @click="onCkeck(item)"
      >
        {{item.name}}
        <p v-if="islink==item.type" class="li-line"></p>
      </li>
    </ul>
    <ul class="top-ul2">
      <li
        :class="islink2==item.type ? 'li-sty2 li-check-sty2' : 'li-sty2'"
        v-for="(item,index) in liList2"
        :key="index"
        @click="onCkeck2(item)"
      >{{item.name}}</li>
    </ul>
    <div class="data-table">
      <data-ranking ref="dataRank" :link="islink" :link2="islink2"></data-ranking>
    </div>
  </div>
</template>

<script>
import dataRanking from './dataRanking.vue'
export default {
  components: { dataRanking },
  data() {
    return {
      liList: [
        { type: 'integral', name: '积分排行榜' },
        { type: 'share', name: '分享阅读榜' },
        { type: 'invitation', name: '邀请人数榜' },
      ],
      islink: 'integral',//第一个li 选择值 排行榜
      liList2: [
        { type: 'current', name: '本月排行' },
        { type: 'last', name: '上月排行' },
      ],
      islink2: 'current',//第儿个li 选择值 本月、上月
    }
  },
  mounted(){
    this.getRankingData(this.islink,this.islink2)
  },
  methods: {
    onCkeck(item) {
      this.islink = item.type
      this.getRankingData(this.islink,this.islink2)
    },
    onCkeck2(item) {
      this.islink2 = item.type
      this.getRankingData(this.islink,this.islink2)
    },
    getRankingData(islink,islink2){//调取子组件获取数据的方法
      this.$refs.dataRank.getData(islink,islink2)
    }
  }
}
</script>

<style lang="less" scoped>
.rank-ing {
  height: 100vh;
  background: #ffffff;
  overflow: scroll;
  font-family: Source Han Sans CN;
  .top-ul1 {
    width: 375px;
    height: 35px;
    align-items: center;
    background: url("./img/bg3.png") no-repeat 50%;
    background-size: 100% 100%;
    display: flex;
    .li-sty {
      width: 125px;
      height: 13px;
      line-height: 13px;
      text-align: center;
      font-weight: 400;
      font-size: 13px;
      color: #666666;
      &:not(:last-child) {
        border-right: 1px solid #ededed;
      }
    }
    .li-check-sty {
      font-weight: 500;
      color: #fc6c21;
    }
    .li-line {
      width: 67px;
      height: 2px;
      margin: 5px auto auto;
      background: #fc6e09;
      border-radius: 10px;
    }
  }
  .top-ul2 {
    width: 355px;
    margin: 15px auto auto;
    display: flex;
    .li-sty2 {
      width: 178px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: url("../../assets/publicImg/li-bg3.png") no-repeat 50%;
      background-size: 100% 100%;
      font-weight: 400px;
      font-size: 13px;
      color: #333333;
    }
    .li-check-sty2 {
      color: #fc6c21;
      font-weight: 500;
    }
  }
  .data-table {
    margin-top: 15px;
  }
}
</style>